import { m } from 'motion/react';

/** Elements the motion components can render as (a fixed table, so components stay static). */
export const MOTION_TAGS = {
  div: m.div,
  section: m.section,
  header: m.header,
  article: m.article,
  aside: m.aside,
  figure: m.figure,
  li: m.li,
  span: m.span,
  p: m.p,
  h1: m.h1,
  h2: m.h2,
  h3: m.h3,
} as unknown as Record<
  | 'div'
  | 'section'
  | 'header'
  | 'article'
  | 'aside'
  | 'figure'
  | 'li'
  | 'span'
  | 'p'
  | 'h1'
  | 'h2'
  | 'h3',
  typeof m.div
>;

export type MotionTag = keyof typeof MOTION_TAGS;
